import styled from 'styled-components';
import { ButtonRounded, H3, Caption, Card, CardBlock } from '@comeon/ui';
import { WE_SPIN_RESOURCE_KEY_LOBBY_CARD_IMAGE } from './constants/we-spin-resource-keys.js';
import { WE_SPIN_FRIENDS_RESOURCE_KEY_LOBBY_CARD_IMAGE } from './constants/we-spin-friends-resource-keys.js';
import { memo } from 'react';

const WeSpinTutorialContentBlock = styled(CardBlock)`
	background: transparent;
	flex-direction: column;
	justify-content: flex-end;
	width: 100%;
	flex: initial;
`;

const WeSpinTutorialHeaderBlock = styled(CardBlock)`
	background: transparent;
	overflow: hidden;
	flex-direction: column;
	flex: initial;
	padding: 0 12px;
`;

const getStyles = backgroundImage => {
	return {
		style: {
			backgroundImage: `var(--we-spin-tutorial-card-bg-gradient), url(${backgroundImage})`,
			backgroundRepeat: 'no-repeat',
			backgroundSize: 'cover',
			backgroundPosition: 'top center',
			borderRadius: '3px',
			transition: 'opacity 0.25s',
			linear: '0s',
			opacity: 1,
			justifyContent: 'flex-end',
			minHeight: '336px'
		}
	};
};

const PositionedFigure = styled.figure`
	order: ${props => (props.order ? props.order : 'inherit')};
`;

const WeSpinLobbyCardTutorial = ({ onClick, translations, resources, isFriends, cssOrder }) => (
	<PositionedFigure order={cssOrder} className="item--large-we-spin tutorial-card u-b-radius u-relative u-m0 u-pb1">
		<Card
			{...getStyles(
				resources[
					isFriends ? WE_SPIN_FRIENDS_RESOURCE_KEY_LOBBY_CARD_IMAGE : WE_SPIN_RESOURCE_KEY_LOBBY_CARD_IMAGE
				]
			)}
		>
			<WeSpinTutorialHeaderBlock>
				<Caption>
					{isFriends
						? translations.WE_SPIN_FRIENDS_LOBBY_CARD_TUTORIAL_CAPTION
						: translations.WE_SPIN_LOBBY_CARD_TUTORIAL_CAPTION}
				</Caption>
				<H3>
					{isFriends
						? translations.WE_SPIN_FRIENDS_LOBBY_CARD_TUTORIAL_TITLE
						: translations.WE_SPIN_LOBBY_CARD_TUTORIAL_TITLE}
				</H3>
			</WeSpinTutorialHeaderBlock>
			<WeSpinTutorialContentBlock padding="0 12px 12px 12px">
				<>
					<p>
						{isFriends
							? translations.WE_SPIN_FRIENDS_LOBBY_CARD_TUTORIAL_DESCRIPTION
							: translations.WE_SPIN_LOBBY_CARD_TUTORIAL_DESCRIPTION}
					</p>
					<ButtonRounded className="btn btn--light u-width-100 btn--wespin" onClick={onClick}>
						{isFriends
							? translations.WE_SPIN_FRIENDS_LOBBY_CARD_TUTORIAL_BUTTON_TEXT
							: translations.WE_SPIN_LOBBY_CARD_TUTORIAL_BUTTON_TEXT}
					</ButtonRounded>
				</>
			</WeSpinTutorialContentBlock>
		</Card>
	</PositionedFigure>
);

const propsEqual = (prevProps, nextProps) => {
	return (
		JSON.stringify(prevProps.resources) === JSON.stringify(nextProps.resources) &&
		JSON.stringify(prevProps.translations) === JSON.stringify(nextProps.translations) &&
		prevProps.cssOrder === nextProps.cssOrder &&
		prevProps.onClick === nextProps.onClick
	);
};

export default memo(WeSpinLobbyCardTutorial, propsEqual);
